import { UIModeSelectorDetailsController } from '../../../../shared/scripts/ui_html/home_page/UIModeSelectorDetailsController.ts';
export class UIWModeSelectorDetailsController extends UIModeSelectorDetailsController {
    onShow() {
        this.modeSelectorContainer.classList.add('hidden');
    }
    onHide() {
        this.modeSelectorContainer.classList.remove('hidden');
    }
    constructor(onStartGame, onRedirectToCasual){
        super(onStartGame, onRedirectToCasual);
        this.modeSelectorContainer = document.getElementById('mm-mode-selector-container');
    }
}
